import React, { Component } from "react";
import "./CarView.css";
import { connect } from "react-redux";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import CarViewDetail from "../CarViewDetail/CarViewDetail";

import CarViewCircles from "../CarViewCircles/CarViewCircles";

import CarViewTextDetail from "../CarViewTextDetail/CarViewTextDetail";

import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import CarGallery from "../CarGallery/CarGallery";
import { isMobile } from "react-device-detect";

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "Arial",
    fontWeight: "bold",
    borderColor: green[500],
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[50]),
    color: green[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: green[100],
      color: theme.palette.getContrastText(green[500]),
      color: green[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

class CarView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      car: JSON.parse(localStorage.getItem("selectedCar"))
    };
  }
  componentDidMount() {
    if (store.getState().carsReducer.car != null) {
      this.setState(
        {
          car: store.getState().carsReducer.car
        },
        () => {
          localStorage.setItem("selectedCar", JSON.stringify(this.state.car));
        }
      );
    }
  }

  handleReservar = selectedPat => {
    if (selectedPat !== 0) {
      this.setState(
        {
          car: {
            ...this.state.car,
            patentamiento: selectedPat
          }
        },
        () => {
          localStorage.setItem("selectedCar", JSON.stringify(this.state.car));
          this.props.history.push("/carForm");
        }
      );
    } else {
      this.setState({});
    }
  };

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: green
      },
      input: {
        display: "none"
      }
    }));

  render() {
    const classes = this.useStyles();

    return (
      <div>
        <Header />
        <CarViewDetail
          image="img/cars/corolla-gray-big.png"
          modelName={this.state.car.model}
          nombre={this.state.car.nombre}
          price={this.state.car.precio}
          version={this.state.car.version}
          motor={this.state.car.motor}
          tipo={this.state.car.tipo}
          color={this.state.car.color}
          year={this.state.car.year}
          gear={this.state.car.gear}
          titulo1={this.state.car.titulo1}
          texto1={this.state.car.descripcion1}
          titulo2={this.state.car.titulo2}
          texto2={this.state.car.descripcion2}
          titulo3={this.state.car.titulo3}
          texto3={this.state.car.descripcion3}
          chasis={this.state.car.chasis}
          handleReservar={this.handleReservar}
        />
        {isMobile ? null : (
          <CarViewCircles
            version={this.state.car.version}
            motor={this.state.car.motor}
            tipo={this.state.car.tipo}
            color={this.state.car.color}
            year={this.state.car.year}
            gear={this.state.car.gear}
          />
        )}
        {isMobile ? null : (
          <CarViewTextDetail
            titulo1={this.state.car.titulo1}
            texto1={this.state.car.descripcion1}
            titulo2={this.state.car.titulo2}
            texto2={this.state.car.descripcion2}
            titulo3={this.state.car.titulo3}
            texto3={this.state.car.descripcion3}
          />
        )}
        {isMobile ? null : (
          <CarGallery className="CarGallery" images={this.state.car.images} />
        )}
        {isMobile ? null : <Footer />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    car: state.carsReducer.car
  };
};

export default connect(mapStateToProps)(CarView);
